import { useEffect } from 'react';

import styles from './CompanyAccounts.module.css';
import { useGetDocuments } from '../../../../api/lendingApi/lendingApiQueries';
import { useDocumentUploadMutation } from '../../../../api/lendingApi/useDocumentUploadMutation';
import { useContextStateKey } from '../../../../hooks/useContextStateKey';
import { useFileUploadReducer } from '../../../../hooks/useFileUploadReducer';
import DocumentUploadSection from '../components/DocumentUploadSection/DocumentUploadSection';
import { useStep } from '../StepContext';

const DOCUMENT_TYPE = 'business accounts';
const listOfInstructions = [
  <>
    Include the P&L page and latest balance sheet broken down by items.{' '}
    <a
      href="https://effective-accounting.co.uk/blog/what-is-included-in-my-company-accounts/"
      target="_blank"
      rel="noreferrer"
    >
      Learn more
    </a>
  </>,
  'Don’t supply draft versions',
];

const CompanyAccounts = () => {
  const { isActive, isError, onRequestUpload } = useStep();
  const stateKey = useContextStateKey();

  const {
    uploadedFiles,
    setAllFiles,
    setFileLoading,
    setFileSuccess,
    setFileError,
    setFileReject,
    removeFile,
  } = useFileUploadReducer();

  const { documents } = useGetDocuments(stateKey);

  const mutation = useDocumentUploadMutation();

  const handleUpload = (stateKey: string, body: FormData) => {
    return mutation.mutateAsync({ stateKey, body });
  };

  useEffect(() => {
    if (documents) {
      const companyAccountsDocuments = documents.data.filter(
        (document) => document.attributes.document_type === DOCUMENT_TYPE,
      );
      setAllFiles(companyAccountsDocuments);
    }
  }, [documents]);

  return (
    <div className={styles.container}>
      <DocumentUploadSection
        documentType={DOCUMENT_TYPE}
        listOfInstructions={listOfInstructions}
        uploadedFiles={uploadedFiles}
        isActive={isActive}
        isError={isError}
        onUpload={handleUpload}
        setFileLoading={setFileLoading}
        setFileSuccess={setFileSuccess}
        setFileError={setFileError}
        setFileReject={setFileReject}
        removeFile={removeFile}
        onRequestUpload={onRequestUpload}
      />
    </div>
  );
};

export default CompanyAccounts;
